import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { SubscriptionType } from "../../types/Student";
import { PdfPreviewContent } from "../PdfPreviewContent";
import { BASE_URL, UPLOAD_IMAGES } from "../../utils/constants";
import { useIES } from "../../hooks/useIES";

export const SubscriptionReportV2 = () => {
  const { IES, isLoading } = useIES();
  const subscriptionDataLS = localStorage.getItem("subscriptionData");
  const preloadedSubscriptionData: SubscriptionType = subscriptionDataLS ? JSON.parse(subscriptionDataLS) : undefined;

  const subscriptionDataFromState = useSelector((state: RootState) => state.subscription);
  const subscriptionData = preloadedSubscriptionData || subscriptionDataFromState;

  const currentDate = new Date().toLocaleDateString("pt-PT");
  const userData = useSelector((state: RootState) => state.login.userData)
  const subscriptionDataCloned = { ...preloadedSubscriptionData } as any;
  useEffect(() => {
    localStorage.removeItem("pdfPreviewTypeData");
    localStorage.removeItem("subscriptionData");
  }, []);

  return (
    <PdfPreviewContent>
      {/* Logo */}
      <div style={{ textAlign: "center", marginBottom: "10px" }}>
        <img
          src={`${IES.LOGO}`}
          alt="Logo"
          style={{ width: "100px", height: "auto" }}
        />
      </div>

      {/* Cabeçalho */}
      <div style={{ textAlign: "center", marginBottom: "15px" }}>
        <h1 style={{ fontSize: "14px", marginBottom: "5px" }}>
          {IES.NAME}- REP. ACADÉMICA
        </h1>
        <h2
          style={{
            fontSize: "12px",
            borderTop: "1px solid #000",
            borderBottom: "1px solid #000",
            padding: "2px 0",
            margin: "5px 0",
          }}
        >
          DIRECÇÃO DE REGISTO ACADÉMICO
        </h2>
        <h3
          style={{
            fontSize: "12px",
            border: "1px solid #000",
            padding: "2px 0",
            margin: "5px 0",
          }}
        >
          FICHA DE INSCRIÇÃO SEMESTRAL
        </h3>
      </div>

      {/* Informações de Inscrição */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "15px",
          color: "blue",
        }}
      >
        {/* <span>
          Inscrição nº:{" "}
          <span style={{ border: "1px solid #000", padding: "2px 5px" }}>
            00000000000000022169
          </span>
        </span> */}
        <span>Original</span>
        <span>Emitido em: {currentDate}</span>
      </div>

      {/* Informações do Estudante */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontWeight: "bold",
        }}
      >
        <span>Dados do Estudante:</span>
        <span>Ano Lectivo: {subscriptionData.academicYear} {subscriptionData.level}º Ano  {subscriptionData.semester}º Semestre </span>
      </div>
      <div style={{ marginBottom: "15px", borderBottom: "1px solid #000", borderTop: "1px solid #000" }}>
        <div style={{ marginTop: "5px" }}>
          <p>Estudante: {subscriptionData.student} Nº: {subscriptionData.studentCode}</p>
          <p>Curso: {subscriptionData?.course}</p>
          {/* <p>Delegação: {enrollmentData.enrollment?.departament} Campus: {enrollmentData?.enrollment?.faculty}</p> */}
        </div>
      </div>

      {/* Disciplinas */}
      <div style={{ marginBottom: "15px" }}>
        <div style={{ marginBottom: "5px", textDecoration: "underline" }}>
          Estudante inscrito nas seguintes disciplinas:
        </div>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={{ border: "1px solid #000", padding: "4px 6px" }}>Ord.</th>
              <th style={{ border: "1px solid #000", padding: "4px 6px" }}>
                Nome da Disciplina
              </th>
              <th style={{ border: "1px solid #000", padding: "4px 6px" }}>Nível</th>
              <th style={{ border: "1px solid #000", padding: "4px 6px" }}>Sem.</th>
            </tr>
          </thead>
          <tbody>
            {subscriptionData.planSubjects?.map((subject, index) => (
              <tr key={`s-${subject.id}`}>
                <td style={{ border: "1px solid #000", padding: "4px 6px" }}>
                  {index + 1}
                </td>
                <td style={{ border: "1px solid #000", padding: "4px 6px" }}>
                  {subject.subject}
                </td>
                <td style={{ border: "1px solid #000", padding: "4px 6px" }}>
                  {subject.level}º
                </td>
                <td style={{ border: "1px solid #000", padding: "4px 6px" }}>
                  {subject.semester}º
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Informações de Pagamento */}
      {/* {subscriptionData?.payment?.reference ? <>
        <div style={{ marginBottom: "10px", padding: "10px 0" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontWeight: "bold",
            }}
          >
            <span>INFORMAÇÃO PARA PAGAMENTO: </span>
          </div>
          <div style={{ marginTop: "5px" }}>
            <p>Entidade: {subscriptionData?.payment?.entity}, Referencia: {subscriptionData?.payment?.reference}, Valor: {subscriptionData?.payment?.totalPrice}MT, Banco: BCI </p>
          </div>
        </div>

      </> : subscriptionData?.payment?.paymentProof ? <>
        <div style={{ marginTop: "5px" }}>
          <p>Valor pago via Comprovativo</p>
        </div>
      </> : <>
      </>}   */}

      {
        subscriptionData?.paymentsReferences && subscriptionData?.paymentsReferences?.length ? (
          <>
            <div style={{ marginBottom: "10px", padding: "10px 0" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: "bold",
                }}
              >
                <span>INFORMAÇÃO PARA PAGAMENTO:</span>
              </div>
              <ul style={{ marginTop: "5px", paddingLeft: "20px" }}>
                {subscriptionData?.paymentsReferences.map((ref, index) => (
                  <li key={index}>
                    Entidade: {ref.entity}, Referência: {ref.referenceCode}, Valor:{" "}
                    {ref.amount}MT
                  </li>
                ))}
              </ul>
            </div>
          </>
        ) : subscriptionData?.payment?.reference ? (
          <>
            <div style={{ marginBottom: "10px", padding: "10px 0" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: "bold",
                }}
              >
                <span>INFORMAÇÃO PARA PAGAMENTO:</span>
              </div>
              <div style={{ marginTop: "5px" }}>
                <p>
                  Entidade: {subscriptionData?.payment?.entity}, Referência:{" "}
                  {subscriptionData?.payment?.reference}, Valor:{" "}
                  {subscriptionData?.payment?.totalPrice}MT, Banco: {subscriptionData?.payment?.bank}
                </p>
              </div>
            </div>
          </>
        ) : subscriptionData?.payment?.paymentProof ? (
          <>
            <div style={{ marginTop: "5px" }}>
              <p>Valor pago via Comprovativo</p>
            </div>
          </>
        ) :
          <></>

      }


      {/* Assinatura */}
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <div
          style={{
            width: "300px",
            borderTop: "1px solid #000",
            margin: "0 auto 5px",
          }}
        ></div>
        <span>{userData?.Fullname} | {userData?.Role}</span>
      </div>

      {/* Rodapé */}
      <div style={{ fontSize: "10px", color: "blue", textAlign: "center" }}>
        <p>Impresso no dia {currentDate}</p>
      </div>
    </PdfPreviewContent>
  );
};
